// extracted by mini-css-extract-plugin
export var completionBody = "_j3-2";
export var completionCard = "_j3-0";
export var completionFooter = "_j3-3";
export var completionTitle = "_j3-1";